module.exports = __webpack_public_path__ + "img/484ba98eea301f9fa70553bd0888b1c7.svg";